exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-circle-custom {\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n}\n.not-img {\n  display: inline-block;\n  border-radius: 26px;\n  width: 26px;\n  height: 26px;\n  color: white;\n  position: relative;\n}\n.not-img > div {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n}\n", ""]);

// exports
